function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "icon_store",
  transform: "translate(-975.764 -1036.69)"
}, React.createElement("path", {
  id: "Path_36",
  "data-name": "Path 36",
  d: "M1008.354,1055.706a1.1,1.1,0,0,1,2.208,0v4.273a1.1,1.1,0,0,1-1.1,1.1H992.367a1.1,1.1,0,0,1-1.1-1.1v-8.547a1.1,1.1,0,0,1,1.1-1.1h17.093a1.1,1.1,0,0,1,0,2.206h-15.99v6.341h14.885Z",
  transform: "translate(20.11 17.697)",
  fill: "#4bc9c9",
  fillRule: "evenodd"
}), React.createElement("path", {
  id: "Path_37",
  "data-name": "Path 37",
  d: "M984.79,1075.486a1.1,1.1,0,1,1-2.206,0v-22.54a1.105,1.105,0,0,1,1.1-1.1h11.4a1.106,1.106,0,0,1,1.1,1.1v21.438h33.4v-26.117a1.1,1.1,0,1,1,2.208,0v27.22a1.1,1.1,0,0,1-1.105,1.1H995.082a1.1,1.1,0,0,1-1.1-1.1v-21.437H984.79Z",
  transform: "translate(8.848 13.585)",
  fill: "#4bc9c9",
  fillRule: "evenodd"
}), React.createElement("path", {
  id: "Path_38",
  "data-name": "Path 38",
  d: "M978.244,1048.266a1.1,1.1,0,1,1,2.205,0v26.117h3.883a1.1,1.1,0,1,1,0,2.205h-4.985a1.1,1.1,0,0,1-1.1-1.1Z",
  transform: "translate(3.218 13.585)",
  fill: "#4bc9c9",
  fillRule: "evenodd"
}), React.createElement("g", {
  id: "Group_18",
  "data-name": "Group 18",
  transform: "translate(975.766 1036.69)"
}, React.createElement("path", {
  id: "Path_39",
  "data-name": "Path 39",
  d: "M977.757,1054.107a1.1,1.1,0,1,1-1.783-1.291l11.4-15.668a1.1,1.1,0,0,1,.891-.453v0h45.581a1.1,1.1,0,0,1,.926.508l11.358,15.618a1.1,1.1,0,1,1-1.78,1.291L1033.28,1038.9H988.819l-11.062,15.209Zm57.01-16.909.177.6A1.1,1.1,0,0,0,1034.767,1037.2Z",
  transform: "translate(-975.765 -1036.69)",
  fill: "#4bc9c9",
  fillRule: "evenodd"
})), React.createElement("path", {
  id: "Path_40",
  "data-name": "Path 40",
  d: "M1010.349,1044.613a1.1,1.1,0,0,1,2.208,0,5.377,5.377,0,0,1-10.754,0,1.1,1.1,0,0,1,2.208,0,3.169,3.169,0,1,0,6.339,0Z",
  transform: "translate(33.783 8.849)",
  fill: "#4bc9c9",
  fillRule: "evenodd"
}), React.createElement("path", {
  id: "Path_41",
  "data-name": "Path 41",
  d: "M983.067,1041.375a1.1,1.1,0,0,1,0-2.205h39.883a1.1,1.1,0,0,1,0,2.205Z",
  transform: "translate(8.044 3.218)",
  fill: "#4bc9c9",
  fillRule: "evenodd"
}), React.createElement("path", {
  id: "Path_42",
  "data-name": "Path 42",
  d: "M998.084,1044.613a1.1,1.1,0,1,1,2.206,0,3.168,3.168,0,0,0,.928,2.242l.057.06a3.171,3.171,0,0,0,5.353-2.3,1.1,1.1,0,0,1,2.208,0,5.373,5.373,0,0,1-9.1,3.871l-.076-.069A5.364,5.364,0,0,1,998.084,1044.613Z",
  transform: "translate(28.958 8.849)",
  fill: "#4bc9c9",
  fillRule: "evenodd"
}), React.createElement("path", {
  id: "Path_43",
  "data-name": "Path 43",
  d: "M990.643,1044.613a1.1,1.1,0,0,1,2.208,0,3.169,3.169,0,1,0,6.339,0,1.1,1.1,0,0,1,2.208,0,5.377,5.377,0,0,1-10.754,0Z",
  transform: "translate(19.304 8.849)",
  fill: "#4bc9c9",
  fillRule: "evenodd"
}), React.createElement("path", {
  id: "Path_44",
  "data-name": "Path 44",
  d: "M1002.912,1044.613a1.1,1.1,0,1,1,2.206,0,5.377,5.377,0,0,1-10.754,0,1.1,1.1,0,0,1,2.208,0,3.17,3.17,0,0,0,6.341,0Z",
  transform: "translate(24.131 8.849)",
  fill: "#4bc9c9",
  fillRule: "evenodd"
}), React.createElement("path", {
  id: "Path_45",
  "data-name": "Path 45",
  d: "M995.468,1044.613a1.1,1.1,0,0,1,2.208,0,5.366,5.366,0,0,1-1.576,3.8l-.076.069a5.372,5.372,0,0,1-9.1-3.871,1.1,1.1,0,1,1,2.206,0,3.174,3.174,0,0,0,5.355,2.3l.055-.06A3.16,3.16,0,0,0,995.468,1044.613Z",
  transform: "translate(14.479 8.849)",
  fill: "#4bc9c9",
  fillRule: "evenodd"
}), React.createElement("path", {
  id: "Path_46",
  "data-name": "Path 46",
  d: "M983.2,1044.613a1.1,1.1,0,0,1,2.208,0,3.17,3.17,0,0,0,6.341,0,1.1,1.1,0,1,1,2.206,0,5.377,5.377,0,0,1-10.754,0Z",
  transform: "translate(9.651 8.849)",
  fill: "#4bc9c9",
  fillRule: "evenodd"
}), React.createElement("path", {
  id: "Path_47",
  "data-name": "Path 47",
  d: "M988.028,1044.613a1.1,1.1,0,0,1,2.208,0,5.374,5.374,0,0,1-9.176,3.8l0,0a5.364,5.364,0,0,1-1.574-3.8,1.1,1.1,0,1,1,2.205,0,3.169,3.169,0,0,0,.928,2.242l0,0,0,0a3.172,3.172,0,0,0,5.41-2.247Z",
  transform: "translate(4.826 8.849)",
  fill: "#4bc9c9",
  fillRule: "evenodd"
}), React.createElement("path", {
  id: "Path_48",
  "data-name": "Path 48",
  d: "M975.764,1044.613a1.1,1.1,0,1,1,2.206,0,3.17,3.17,0,1,0,6.341,0,1.1,1.1,0,1,1,2.205,0,5.376,5.376,0,1,1-10.752,0Z",
  transform: "translate(0 8.849)",
  fill: "#4bc9c9",
  fillRule: "evenodd"
}));

var SvgIconStore = function SvgIconStore(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 70.576,
    height: 53.484,
    viewBox: "0 0 70.576 53.484",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconStore, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_store.c84e776b.svg";
export { ForwardRef as ReactComponent };